import React, { useState, useRef, useEffect } from 'react';
import { Modal, Button, Form, Spinner, Alert, Row, Col } from 'react-bootstrap';
import { FaSignature, FaCheckCircle } from 'react-icons/fa';
import { confirmarEntregaPrestamo, obtenerPrestamoPorId, obtenerPrestamosPorOt } from '../../api/common';
import SignatureCanvas from 'react-signature-canvas';
import Swal from 'sweetalert2';
import { useAuth } from '../../hooks/useAuth';
//import { uploadFile } from '../../firebase/config'; // Ajustar según tu configuración de Firebase

const ModalConfirmarEntrega = ({ show, onHide, otId, onConfirmado, idPrestamo=null }) => {


  const { userData } = useAuth();
  const sigCanvas = useRef(null);
  const [loading, setLoading] = useState(false);
  const [prestamos, setPrestamos] = useState([]);
  const [prestamoSeleccionado, setPrestamoSeleccionado] = useState('');
  const [observaciones, setObservaciones] = useState('');
  const [firmaCargada, setFirmaCargada] = useState(false);
  const [nombreRecibe, setNombreRecibe] = useState('');
  const [cargoRecibe, setCargoRecibe] = useState('');
  const [recibidoSatisfaccion, setRecibidoSatisfaccion] = useState(false);

 
  useEffect(() => {
    console.log('useEffect ModalConfirmarEntrega - show:', show, 'otId:', otId, 'idPrestamo:', idPrestamo);
    if (show && (otId || idPrestamo)) {
      cargarPrestamos();
    }
  }, [show, otId, idPrestamo]);

  const cargarPrestamos = async () => {
    let resp;
    try {

      if (idPrestamo) {
        resp=   await obtenerPrestamoPorId(idPrestamo);
      } else {
        resp = await obtenerPrestamosPorOt(otId);
      }
  

      if (resp.status === 200) {
        if (idPrestamo) {
            setPrestamos([resp.data.data]);
            setPrestamoSeleccionado(resp.data.data._id);
          }else {
          // Filtrar solo préstamos activos que no estén confirmados
            const prestamosActivos = (resp.data.data || []).filter(
              p => p.estado === 'activo' && !p.confirmacionEntrega?.confirmado
            );
            setPrestamos(prestamosActivos);
          if (prestamosActivos.length === 1) {
            setPrestamoSeleccionado(prestamosActivos[0]._id);
          }
        }
      }
    } catch (error) {
      console.error('Error al cargar préstamos:', error);
    }
  };

  const limpiarFirma = () => {
    if (sigCanvas.current) {
      sigCanvas.current.clear();
      setFirmaCargada(false);
    }
  };

  const handleFirmaChange = () => {
    if (sigCanvas.current && !sigCanvas.current.isEmpty()) {
      setFirmaCargada(true);
    }
  };

  const handleConfirmar = async () => {
    // Validaciones
    if (!prestamoSeleccionado) {
      Swal.fire('Validación', 'Debe seleccionar un préstamo', 'warning');
      return;
    }

    if (!sigCanvas.current || sigCanvas.current.isEmpty()) {
      Swal.fire('Validación', 'Debe firmar para confirmar la entrega', 'warning');
      return;
    }

    try {
      setLoading(true);

      // Convertir firma a blob
      const firmaDataURL = sigCanvas.current.toDataURL('image/png');
      const blob = await (await fetch(firmaDataURL)).blob();

      // Subir firma a Firebase
      /*const firmaURL = await uploadFile(
        blob,
        `firmas/prestamos/${prestamoSeleccionado}_${Date.now()}.png`
      );*/

      // Confirmar entrega
      const datosConfirmacion = {
        usuarioTecnico: userData.uid,
        nombreTecnico: userData.nombre,
        firma: '',//firmaURL,
        observaciones,
        nombreRecibe,
        cargoRecibe,
        recibidoSatisfaccion
      };

      const resp = await confirmarEntregaPrestamo(prestamoSeleccionado, datosConfirmacion);

      if (resp.status === 200) {
        Swal.fire({
          icon: 'success',
          title: '¡Entrega Confirmada!',
          text: 'La entrega de equipos ha sido confirmada exitosamente',
          confirmButtonText: 'Aceptar'
        });
        
        onConfirmado && onConfirmado();
        handleClose();
      } else {
        Swal.fire('Error', resp.message || 'No se pudo confirmar la entrega', 'error');
      }
    } catch (error) {
      console.error('Error al confirmar entrega:', error);
      Swal.fire('Error', 'Ocurrió un error al confirmar la entrega', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setPrestamoSeleccionado('');
    setObservaciones('');
    setNombreRecibe('');
    setCargoRecibe('');
    setRecibidoSatisfaccion(false);
    limpiarFirma();
    onHide();
  };

  const prestamoActual = prestamos.find(p => p._id === prestamoSeleccionado);

  return (
    <Modal 
    show={show} 
    onHide={handleClose} size="lg" 
    centered
    
    >
      <Modal.Header closeButton className="bg-primary text-white">
        <Modal.Title>
          <FaCheckCircle className="me-2" />
          Confirmar Entrega de Equipos
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body
      style={{height:'80vh', overflowY: 'auto'}}
      >
        {prestamos.length === 0 ? (
          <Alert variant="info">
            No hay préstamos pendientes de confirmación para esta OT.
          </Alert>
        ) : (
          <>
            {/* Selección de préstamo */}
            <Form.Group className="mb-3">
              <Form.Label>Préstamo</Form.Label>
              <Form.Select
                value={prestamoSeleccionado}
                onChange={(e) => setPrestamoSeleccionado(e.target.value)}
                disabled={prestamos.length === 1}
              >
                <option value="">Seleccione un préstamo...</option>
                {prestamos.map(prestamo => (
                  <option key={prestamo._id} value={prestamo._id}>
                    {prestamo.numeroActa} - {prestamo.equipos?.length || 0} equipos
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            {/* Detalle de equipos */}
            {prestamoActual && (
              <div className="mb-3">
                <strong>Equipos a entregar:</strong>
                <ul className="mt-2">
                  {prestamoActual.equipos.map((eq, index) => (
                    <li key={index}>
                      {eq.codigo} - {eq.descripcion} ({eq.serie})
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* Técnico */}
            <Row className="mb-3">
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Persona que recibe <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Nombre de quien recibe"
                    value={nombreRecibe}
                    onChange={(e) => setNombreRecibe(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Cargo <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Cargo de quien recibe"
                    value={cargoRecibe}
                    onChange={(e) => setCargoRecibe(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3">
              <Form.Check
                type="checkbox"
                label="Se reciben todos los equipos a satisfacción"
                checked={recibidoSatisfaccion}
                onChange={(e) => setRecibidoSatisfaccion(e.target.checked)}
              />
            </Form.Group>

            {/* Observaciones */}
            <Form.Group className="mb-3">
              <Form.Label>Observaciones</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                value={observaciones}
                onChange={(e) => setObservaciones(e.target.value)}
                placeholder="Observaciones sobre la entrega..."
              />
            </Form.Group>

            {/* Firma */}
            <Form.Group className="mb-3">
              <Form.Label>
                <FaSignature className="me-2" />
                Firma del Responsable
                <span className="text-danger"> *</span>
              </Form.Label>
              <div
                className="border rounded p-2"
                style={{ backgroundColor: '#f8f9fa' }}
              >
                <SignatureCanvas
                  ref={sigCanvas}
                  canvasProps={{
                    width: 500,
                    height: 200,
                    className: 'signature-canvas',
                    style: {
                      border: '1px solid #dee2e6',
                      borderRadius: '4px',
                      backgroundColor: 'white',
                      width: '100%',
                      height: '200px'
                    }
                  }}
                  onEnd={handleFirmaChange}
                />
                <div className="text-end mt-2">
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={limpiarFirma}
                  >
                    Limpiar Firma
                  </Button>
                </div>
              </div>
              <Form.Text className="text-muted">
                Firme en el recuadro blanco para confirmar la recepción de los equipos
              </Form.Text>
            </Form.Group>
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={loading}>
          Cancelar
        </Button>
        <Button
          variant="success"
          onClick={handleConfirmar}
          disabled={loading || !prestamoSeleccionado || prestamos.length === 0 || !nombreRecibe || !cargoRecibe}
        >
          {loading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                className="me-2"
              />
              Confirmando...
            </>
          ) : (
            <>
              <FaCheckCircle className="me-2" />
              Confirmar Entrega
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalConfirmarEntrega;